module.exports = __webpack_public_path__ + "static/media/square_blank_gray.2be23892.png";